import { api } from './client';

/**
 * Phase 3 (2026-09-12): the wage-sheet READ mirror — imported legacy
 * du_ziniarastis sheets with their worker rows, taxes and the journal link.
 * Read-only on both planes.
 */
export interface WageSheetDto {
  id: number;
  year: number;
  month: number;
  sheetDate: string;
  isFinal: boolean;
  documentNumber: string | null;
  journalEntryId: number;
  costAccount: number;
  rateGpm: number;
  rateSodraEmployee: number;
  rateSodraEmployer: number;
  workers: number;
  grossPay: number;
  netPayable: number;
  deductedGpm: number;
  deductedSodra: number;
  employerContributions: number;
}

export interface WageSheetItemDto {
  id: number;
  workerName: string;
  contractSerial: string | null;
  contractNumber: number;
  grossPay: number;
  netPayable: number;
  payableTotal: number;
  deductedGpm: number;
  deductedGpmSickLeave: number;
  deductedPsd: number;
  deductedPsdSickLeave: number;
  deductedSodra: number;
  contributionPsd: number;
  contributionSodra: number;
  contributionGuaranteeFund: number;
  npdApplied: number;
  pnpdApplied: number;
  holidayPay: number;
  sickLeavePay: number;
  normalHours: number;
  overtimeNightHours: number;
  sickDays: number;
  holidayDays: number;
  paidOutDate: string | null;
  imprestDeducted: number;
}

export interface WageSheetDetailDto extends Omit<WageSheetDto,
  'workers' | 'grossPay' | 'netPayable' | 'deductedGpm' | 'deductedSodra' | 'employerContributions'> {
  ratePsdEmployee: number;
  ratePsdEmployer: number;
  rateGuaranteeFund: number;
  npdFormula: string | null;
  remarks: string | null;
  items: WageSheetItemDto[];
}

export const wageSheetsApi = {
  list: (params: { year?: number; month?: number } = {}) =>
    api.get<WageSheetDto[]>('/wage-sheets', params),

  getById: (id: number) => api.get<WageSheetDetailDto>(`/wage-sheets/${id}`),
};

// ── P1e: NATIVE wage-sheet generation (GenerateWageSheet DTOs) ──

export interface GeneratedWageItemDto {
  workerId: number;
  workerName: string;
  contractNumber: number;
  contractSerial: string;
  contractWage: number;
  grossPay: number;
  netPayable: number;
  deductedGpm: number;
  deductedPsd: number;
  deductedSodra: number;
  contributionPsd: number;
  contributionSodra: number;
  contributionGuaranteeFund: number;
  imprestDeducted: number;
  notes: string;
}

export interface GeneratedWageSheetDto {
  sheetId: number;
  documentNumber: string;
  year: number;
  month: number;
  isFinal: boolean;
  items: GeneratedWageItemDto[];
}

// The mirror API + the native generate call.
export const nativeWageSheetsApi = {
  generate: (year: number, month: number) =>
    api.post<GeneratedWageSheetDto>('/payroll/sheets/generate', { year, month, isFinal: true }),

  post: (sheetId: number) =>
    api.post<PostResultDto>(`/payroll/sheets/${sheetId}/post`, {}),

  markItemPaid: (sheetId: number, itemId: number, paidOutDate: string) =>
    api.post<void>(`/payroll/sheets/${sheetId}/items/${itemId}/mark-paid?paidOutDate=${paidOutDate}`, {}),
};

export interface PostResultDto {
  journalEntryId: number;
  totalCosts: number;
  totalNet: number;
}
